<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
    
      <v-flex v-if="isAuthenticated" xs4>
        <div class="bienvenido">
        <h3 class="headline text-xs-center">Bienvenido</h3>
        <p class="text-xs-center">{{ nombreUsuario }}</p>
        </div>
      </v-flex>

      <v-flex v-if="isAuthenticated && mostrarAvisoCuestionariosPendientes && (numeroCuestionariosPendientes > 0)" xs4>
        <v-dialog v-model="dialogCuestionariosPendientes" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">Cuestionarios pendientes</v-card-title>
            <v-card-text>Tiene uno o varios cuestionarios pendientes de cumplimentar. Desea cumplimentarlos ahora ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="cumplimentarCuestionarios">Si</v-btn>
              <v-btn color="primary" @click="cancelarAvisoCuestionariosPendientes">No</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      
      <v-flex xs12 sm8 md4 v-if="!isAuthenticated">
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Identificación</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="fmLogin" v-model="valid" lazy-validation>
              <v-alert :value="error" type="warning">{{ error }}</v-alert>
              
              <v-text-field 
                class="pt-3"
                v-model="email" 
                prepend-icon="person" 
                name="login" 
                label="Correo electrónico" 
                type="text"
                required
                :rules="emailRules">
              </v-text-field>
              
              <v-text-field 
                v-model="password" 
                id="password" 
                prepend-icon="lock" 
                name="password" 
                label="Contraseña" 
                type="password"
                required
                :rules="passwordRules">
              </v-text-field>

              <v-checkbox
                v-model="guardarDatosAcceso"
                label="Guardar datos de acceso para una próxima conexión"
              ></v-checkbox>

              <div class="pt-5">
              <router-link to="/login/signup">Desea registrarse o cambiar su contraseña ?</router-link>
              </div>
              
              <div class="pt-2">
              <router-link to="/login/signin">Ya tiene un código para activar su contraseña ?</router-link>
              </div>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="login">Entrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
  
  
    </v-layout>
  </v-container>
</template>

<style>
.bienvenido {
  height: 80vh;  
}
</style>

<script>
  import { AUTH_REQUEST } from '../store/actions/auth'
  import { USER_ANULAR_AVISO_CUESTIONARIOS_PENDIENTES } from '../store/actions/user'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'login',
    computed: {
      ...mapGetters(['isAuthenticated', 'authStatus', 'numeroCuestionariosPendientes']),
      ...mapState({
        nombreUsuario: state => state.user.profile.NOMBRE,
        mostrarAvisoCuestionariosPendientes: state => state.user.mostrarAvisoCuestionariosPendientes
      })
    },
    data () {
      return {
        dialogCuestionariosPendientes: true,
        
        email: localStorage.getItem('user-email') || '',
        password: localStorage.getItem('user-password') || '',
        guardarDatosAcceso: localStorage.getItem('user-persist') === 'SI',
        
        error: '',
        valid: true,
        emailRules: [
          v => !!v || 'Debe indicar la dirección de correo electrònico',
          v => /.+@.+/.test(v) || 'Dirección de correo electrónico inválida'
        ],
        passwordRules: [
          v => !!v || 'Debe indicar la contraseña',
          v => (v && v.length >= 4) || 'La contraseña debe contener al menos 4 caracteres'
        ]
      }
    },
    props: {
      source: String
    },
    methods: {
      login: function () {
        if (this.$refs.fmLogin.validate()) {
          this.$store.dispatch(AUTH_REQUEST, { email: this.email, password: this.password, guardarDatosAcceso: this.guardarDatosAcceso })
          .then(() => {
            this.error = ''
            this.$router.push('/')
          })
          .catch(error => {
            this.error = error
          })
        }
      },
      cancelarAvisoCuestionariosPendientes: function () {
        this.dialogCuestionariosPendientes = false;
        this.$store.dispatch(USER_ANULAR_AVISO_CUESTIONARIOS_PENDIENTES);
        
      },
      cumplimentarCuestionarios: function () {
        this.dialogCuestionariosPendientes = false;
        this.$router.push('/cuestionarios')
      }
    },
  }
</script>

